// Single source of truth for Majesty Hostel contact details.
// The hostel uses one public address, majestyhostel@gmail.com, everywhere —
// Contact.tsx, Footer.tsx, structured data, and the transactional emails.
// Update these values in one place.

export const CONTACT = {
  address: {
    line1: "Near Maybeth Guest House",
    line2: "Rasta Down, Koforidua, Ghana",
    full: "Near Maybeth Guest House, Rasta Down, Koforidua, Ghana",
  },
  phones: ["0540 670 010", "0244 629 601"],
  emails: {
    general: "majestyhostel@gmail.com",
    bookings: "majestyhostel@gmail.com",
  },
  map: {
    embedUrl: "https://maps.google.com/maps?q=3P5H+JQ,Koforidua&output=embed",
    plusCode: "3P5H+JQ",
  },
  // Nearest landmark, used by the hero location widget.
  campus: {
    name: "Koforidua Technical University",
    distanceKm: 1.2,
    byCar: "5 min",
    byWalk: "12 min",
    // Directions from campus → the hostel (uses the map plus code).
    mapUrl:
      "https://www.google.com/maps/dir/?api=1&origin=Koforidua+Technical+University&destination=3P5H%2BJQ+Koforidua",
  },
} as const;
